module.exports = __webpack_public_path__ + "img/liftIcon14.865d1e78.png";